export const Checkmark = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 4L8 17L2 11" stroke="currentColor" strokeWidth="2.2" />
  </svg>
)
